import { CanaryMetadata, CanaryPostMortem } from '@paragon/contract-library';

import { DesignService } from '../connections';

export function sendReport(
  causeOfDeath: string,
  componentDesignGuid: string | null = null,
  metadata: CanaryMetadata = {},
) {
  const postMortem: CanaryPostMortem = { causeOfDeath, componentDesignGuid, metadata };

  if (process.env.NODE_ENV !== 'production') {
    console.log('Canary report triggered', postMortem);
    return;
  }

  (async () => {
    try {
      await DesignService.post('canary', { data: postMortem });
    } catch (error) {
      console.log(`Warning: canary report failed—${causeOfDeath}`);
    }
  })();
}
